import { inject, NgModule } from '@angular/core';

import { ActivatedRouteSnapshot, RouterModule, RouterStateSnapshot, Routes } from '@angular/router';
import { PageNotFoundComponent } from './core/error-pages/page-not-found.component';
import { AuthenticationGuard } from './core/user/authentication.guard';
import { RegistrationComponent } from './core/registration/registration.component';
import { LoginFailedComponent } from './core/error-pages/login-failed.component';
import { M_LOGIN_REDIRECT_CALLBACK_URL } from './core/navigation/mlogin-navigation.service';
import { mloginRedirectGuard } from './core/navigation/mlogin-redirect-guard';

const routes: Routes = [
  {
    path: '',
    runGuardsAndResolvers: 'always',
    canActivate: [(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthenticationGuard).canActivate(next, state)],
    children: [
      {
        path: 'ladeloesung',
        loadChildren: () =>
          import('./ladeloesung/ladeloesung.module').then(
            (mod) => mod.LadeloesungModule,
          ),
      },
      {
        path: 'partnerkraft',
        loadChildren: () =>
          import('./partnerkraft/partnerkraft.module').then(
            (mod) => mod.PartnerkraftModule,
          ),
      },
      {
        path: 'card-ordering',
        redirectTo: '/ladeloesung/card-ordering',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: M_LOGIN_REDIRECT_CALLBACK_URL,
    canActivate: [mloginRedirectGuard],
    children: []
  },
  {
    path: 'registration',
    component: RegistrationComponent,
    data: {
      pageTitle: 'Registrierung',
    },
  },
  {
    path: 'login-failed',
    component: LoginFailedComponent,
    data: {
      pageTitle: 'Anmeldung fehlgeschlagen',
    },
  },
  {
    path: '**',
    component: PageNotFoundComponent,
    data: {
      pageTitle: 'Fehler 404: Seite nicht gefunden',
    },
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: false,
      paramsInheritanceStrategy: 'always',
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [
    RouterModule,
  ],
})
export class AppRoutingModule {
}
